import { useStyletron } from 'baseui';
import { Modal, ModalBody } from 'baseui/modal';
import { Block } from 'baseui/block';
import { HeadingLarge, ParagraphMedium } from 'baseui/typography';
import { useDispatch } from 'react-redux';
import { routeTo, setPortalElement } from '../application/actions/ui';
import useLocale from '../hooks/useLocale';
import ReDoButton from './ReDoButton';
import girl_glasses from '../assets/images/girl_glasses.png';


// ReDoAuthGate is the register/login prompt shown when a logged-out visitor on the
// public landing page tries to open a solution or challenge. It is registered as the
// `authGate` portal element and opened via dispatch(setPortalElement({ element: 'authGate' })).
const ReDoAuthGate = ({ ...props }) => {
  const dispatch = useDispatch();
  const { t } = useLocale();
  const [css, theme] = useStyletron();

  const close = () => dispatch(setPortalElement())

  const goRegister = () => {
    dispatch(setPortalElement())
    dispatch(routeTo({ view: 'signup' }))
  }

  const goLogin = () => {
    dispatch(setPortalElement())
    dispatch(routeTo({ view: 'login' }))
  }

  return (
    <Modal
      overrides={{
        DialogContainer: {
          style: {
            backgroundColor: theme.colors.primary400 + 'e6',
          }
        },
        Dialog: {
          style: {
            width: 'calc(100vw - 2ch)',
            maxWidth: '400px',
            padding: '1ch',
            borderRadius: '21px',
            marginLeft: '1ch',
            marginRight: '1ch',
            '@media (min-width: 600px)': {
              padding: '2ch',
            },
          }
        },
        Close: {
          style: {
            color: theme.colors.primary300,
            width: '36px',
            height: '36px',
            transform: 'scale(2)',
          }
        }
      }}
      onClose={close}
      isOpen={true}>
      <ModalBody>
        <Block marginTop='3ch' maxHeight='80vh' overflow='auto' display='flex' flexDirection='column'>
          <HeadingLarge marginTop='0' overrides={{ Block: { style: { fontWeight: '600' } } }}>{t('landing.authgate_title')}</HeadingLarge>
          <ParagraphMedium marginTop='0'>{t('landing.authgate_text')}</ParagraphMedium>
          <img width='100%' className={css({ height: '120px', objectFit: 'contain', flexShrink: '0', '@media (min-width: 600px)': { height: '160px' } })} src={girl_glasses} alt="" />
          <Block marginTop='2ch' display='flex' flexDirection='column' gridGap='1ch'>
            <ReDoButton kind='brand' onClick={goRegister}>{t('landing.authgate_register')}</ReDoButton>
            <ReDoButton
              kind='brand'
              onClick={goLogin}
              overrides={{ BaseButton: { style: { backgroundColor: 'transparent', color: theme.colors.black, border: `2px solid ${theme.colors.black}` } } }}
            >
              {t('landing.authgate_login')}
            </ReDoButton>
          </Block>
        </Block>
      </ModalBody>
    </Modal>
  );
};

export default ReDoAuthGate;
